import { useEffect, useState, useRef } from 'react';
import { hasLogin, login } from '@/api/auth';

const Intercept = ({ children }) => {
  const [pass, setPass] = useState(false);
  const initRef = useRef(false);

  useEffect(() => {
    if (initRef.current) return;
    initRef.current = true;

    (async () => {
      if (!hasLogin()) {
        const token = await login();
        if (!token) {
          setPass(false);
          return;
        }
      }
      setPass(true);
    })();
  }, []);

  return pass ? children : null;
};

export default Intercept;
